/**
 * /tenants/$slug/authentication/authenticators/identity-checks — how people
 * prove who they are at first passkey and recovery.
 */

import { createFileRoute } from "@tanstack/react-router";
import { IdentityChecksPage } from "@/features/identity-trust-settings/pages/identity-trust-settings-page";

export const Route = createFileRoute("/_authed/tenants/$slug/authentication/authenticators/identity-checks")({
  component: IdentityChecksPage,
});
